import {AxiosInstance, AxiosResponse} from 'axios';
import {userAPI, authUserAPI} from '@/core/api';
import {IAuthAppleRequest, IAuthGoogleRequest, IOrganizationUserInfo} from '@/utils/types';
import {API_URL} from '../enums/api-url.enum';
import {
  IUserLoginRequest,
  IUserRegisterLoginResponse,
  IUserRegisterRequest,
  IUserChangeProfileRequest,
  IUserChangeProfileResponse,
  ISetNewPasswordRequest,
  IVerifyOldPasswordRequest,
  IResetPasswordRequest,
  IUserTable,
  IAttendeeIdentity,
  IAttendeeCardStatus,
} from '../types/user.interface';

class UserService {
  static create = async (reqBody: IUserRegisterRequest): Promise<AxiosResponse<IUserRegisterLoginResponse>> =>
    authUserAPI.post(API_URL.USER_CREATE, reqBody);

  static login = async (reqBody: IUserLoginRequest): Promise<AxiosResponse<IUserRegisterLoginResponse>> =>
    authUserAPI.post(API_URL.USER_LOGIN, reqBody);

  static getUserInfo = async (id: number): Promise<AxiosResponse<IOrganizationUserInfo>> =>
    userAPI.get(`${API_URL.USER_INFO}/${id}`);

  static verifyOldPassword = async (
    reqBody: IVerifyOldPasswordRequest,
    apiInstance: AxiosInstance
  ): Promise<AxiosResponse> => apiInstance.post(API_URL.VERIFY_OLD_PASSWORD, reqBody);

  static setNewPassword = async (reqBody: ISetNewPasswordRequest, apiInstance: AxiosInstance): Promise<AxiosResponse> =>
    apiInstance.post(API_URL.SET_NEW_PASSWORD, reqBody);

  static resetPassword = async (reqBody: IResetPasswordRequest, apiInstance: AxiosInstance): Promise<AxiosResponse> =>
    apiInstance.post(API_URL.RECOVER_PASSWORD, reqBody);

  static changeProfile = async (
    reqBody: IUserChangeProfileRequest
  ): Promise<AxiosResponse<IUserChangeProfileResponse>> => {
    return userAPI.put(`${API_URL.USER_INFO}/${reqBody.id}`, reqBody);
  };

  static googleAuth = async (reqBody: IAuthGoogleRequest): Promise<AxiosResponse<IUserRegisterLoginResponse>> =>
    authUserAPI.post(API_URL.USER_GOOGLE_LOGIN, reqBody);

  static appleAuth = async (reqBody: IAuthAppleRequest): Promise<AxiosResponse<IUserRegisterLoginResponse>> =>
    authUserAPI.post(API_URL.USER_APPLE_LOGIN, reqBody);

  static getUserTables = async ({
    userId,
    eventId,
  }: {
    userId: number;
    eventId: number;
  }): Promise<AxiosResponse<IUserTable[] | []>> =>
    userAPI.get(`${API_URL.USER_INFO}/${userId}/events/${eventId}/tables`);

  static ensureUserHaveAttendeeIdentity = async (eventId: number): Promise<AxiosResponse<IAttendeeIdentity>> =>
    userAPI.post(`${API_URL.USER_INFO}/events/${eventId}/attendee-session`);

  // static startUserCardAttachment = async (idempotencyKey: string, returnRoute: string): Promise<AxiosResponse<IAttendeeCardStatus>> =>
  //   userAPI.post(`${API_URL.USER_INFO_START_CARD_ATTACHMENT}`, {returnRoute}, {
  //     headers: {'Idempotency-Key': idempotencyKey},
  //   });
  static startUserCardAttachment = async (
    idempotencyKey: string,
    returnRoute: string
  ): Promise<AxiosResponse<IAttendeeCardStatus>> =>
    userAPI.post(`${API_URL.USER_INFO_START_CARD_ATTACHMENT}`, JSON.stringify(returnRoute), {
      headers: {
        'Idempotency-Key': idempotencyKey,
        'Content-Type': 'application/json',
      },
    });
}

export {UserService};
